import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-910da748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row setting-content-box-subtitle" }
const _hoisted_2 = {
  key: 0,
  class: "setting-content-container"
}
const _hoisted_3 = {
  key: 0,
  class: "gordita-400-11 settings-incompatible-note"
}
const _hoisted_4 = {
  key: 1,
  class: "row ibf-h5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_incredi_select_menu = _resolveComponent("incredi-select-menu")!
  const _component_incredi_link = _resolveComponent("incredi-link")!
  const _component_settings_item_box = _resolveComponent("settings-item-box")!

  return (_openBlock(), _createBlock(_component_settings_item_box, {
    header: _ctx.$t('settings.summary.windows.general.backup.title')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.summary.windows.general.backup.backupSelection.text')), 1)
      ]),
      (_ctx.shouldDisplayBackupDropdown())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_incredi_select_menu, {
              value: _ctx.selectedBackupName,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedBackupName) = $event)),
              disable: _ctx.disable,
              dense: "",
              style: {"width":"256px"},
              options: _ctx.backupMachinesNamesList,
              onInput: _ctx.handleSelection
            }, null, 8, ["value", "disable", "options", "onInput"]),
            (_ctx.shouldDisplayIncompatibleNote)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('settings.summary.windows.general.backup.incompatibleBackupSelectionErrorMessage')), 1))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('settings.summary.windows.general.backup.noBackupText')) + " ", 1),
              _createVNode(_component_incredi_link, {
                text: _ctx.$t('settings.summary.windows.general.backup.learnMore.text'),
                url: _ctx.learnMoreLink
              }, null, 8, ["text", "url"])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["header"]))
}